"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Utils = _interopRequireWildcard(require("./utils"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var PARAMS_TEST_PATTERN = /{(.*?)}/;
var PARAMS_MATCH_PATTERN = /{*[^{}]+}*/g;

var _default = function _default(key) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (key && params && params.length && PARAMS_TEST_PATTERN.test(key)) {
    var values = key.match(PARAMS_MATCH_PATTERN) || [];
    return values.reduce(function (acc, item, i) {
      var fragment = Utils.isMarker(item) ? Utils.createFragment(params, item, i) : item;

      if (acc.length && Utils.isPrimitive(fragment)) {
        Utils.mergeFragments(acc, fragment);
      } else {
        acc.push(fragment);
      }

      return acc;
    }, []);
  }

  return key;
};

exports["default"] = _default;